import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { times, equals } from 'ramda';
import { Collapse } from 'react-collapse';
import Slider from 'material-ui/Slider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

import VASScale from '../../assets/VAS-outlined.svg';

import Grade from '../Grade';

import { wrapper, title, desc, answerHealthTodayScale } from './GradeableSection.less';
import { colors } from 'styles/provider';

const theme2 = getMuiTheme({
  slider: {
    trackSize: 8,
    handleSizeDisabled: 25,
    handleSize: 25,
    selectionColor: colors.clrSecondary,
    handleFillColor: colors.clrSecondary,
    rippleColor: colors.clrSecondary,
  },
});

class GradeableSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sliderValue: undefined,
    };
  }

  render() {
    const {
      section,
      grades,
      getLocale,
      value,
      isOpen,
      onOpen,
      onSelect,
      estimateSlider,
      estimateValue,
      estimateOnChange,
      hasGrades,
      infoComponent,
    } = this.props;

    const getSectionGradeCollapse = grade => {
      return (
        <Collapse key={`${section}_grd_${grade}`} isOpened={isOpen || equals(value, grade) || false}>
          <Row>
            <Col xs={12}>
              <Grade
                grade={grade}
                isSelected={isOpen && equals(value, grade)}
                text={getLocale(grade)}
                description={getLocale(grade + '.description')}
                onSelect={isOpen ? onSelect(grade) : onOpen}
              />
            </Col>
          </Row>
        </Collapse>
      );
    };

    const getSectionGrade = grade => {
      if (section === 'prEDSS' && grade === 6) {
        return (
          <React.Fragment key={grade}>
            {getSectionGradeCollapse(6)}
            {getSectionGradeCollapse(6.5)}
          </React.Fragment>
        );
      }
      return getSectionGradeCollapse(grade);
    };

    return (
      <Grid fluid className={wrapper}>
        <Row>
          <Col xs={12} sm={4}>
            <h5 className={title}>{getLocale('title')}</h5>
            {hasGrades && isOpen && (
              <p className={desc} dangerouslySetInnerHTML={{ __html: getLocale('description') }} />
            )}
            {infoComponent && <div style={{ margin: '2rem 0rem' }}>{infoComponent()}</div>}
          </Col>
          {hasGrades && (
            <Col xs={12} sm={8}>
              <div>
                {!isOpen && value === undefined && <Grade grade="" onSelect={onOpen} />}
                {times(n => getSectionGrade(n))(grades)}
              </div>
            </Col>
          )}
          {estimateSlider && (
            <Col xs={12}>
              <Row style={hasGrades ? { marginTop: '2.5rem' } : { display: 'flex', alignItems: 'center' }}>
                <Col xs={12} sm={4}>
                  <p className={desc} dangerouslySetInnerHTML={{ __html: getLocale('VASDescription') }} />
                </Col>
                <Col xs={12} sm={8} style={{ paddingLeft: '3rem', marginTop: '-1.5rem' }}>
                  <Row>
                    <Col xs={12}>
                      <img src={VASScale} />
                    </Col>
                    <Col xs={12} className={answerHealthTodayScale}>
                      <MuiThemeProvider muiTheme={theme2}>
                        <Slider
                          min={0}
                          max={100}
                          step={1}
                          value={estimateValue}
                          onChange={estimateOnChange}
                          style={{ width: '92.4%' }}
                          disabled={!estimateOnChange}
                        />
                      </MuiThemeProvider>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          )}
        </Row>
      </Grid>
    );
  }
}

GradeableSection.propTypes = {
  section: PropTypes.string.isRequired,
  grades: PropTypes.number.isRequired,
  getLocale: PropTypes.func.isRequired,
  value: PropTypes.number,
  isOpen: PropTypes.bool,
  onOpen: PropTypes.func,
  onSelect: PropTypes.func,
  estimateSlider: PropTypes.bool,
  estimateValue: PropTypes.number,
  estimateOnChange: PropTypes.func,
  infoComponent: PropTypes.func,
};

export default GradeableSection;
